module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/icon_app-82958de996aad528047252c67d635a0f.png";